import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert, Modal, Input } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from 'react-select';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

    const AddGrievanceCase = () => {
        const history = useHistory();

        const [inputs, setInputs] = useState([]);
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');
        const [description, setDescription] = useState('')
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaSaved, setIpaSaved] = useState(false)
        const [ipaNo, setIpaNo] = useState('')

        const [modal_item, setmodal_item] = useState(false);

        const [caseOptions, setCaseOptions] = useState([])
        const [entryTypes, setEntryTypes] = useState(["Issue Detail Description","Findings","Recommendations","Employee Response"])
        
        const [natureofGrievance, setNatureofGrievance] = useState('')
        const [processType, setProcessType] = useState('')
        const [pTypeList, setPTypeList] = useState(["Job Description and Responsibilities", "Renumeration and Benefits", "Work Environment and Culture", "Work Enablers and Gear", "Safety and Security Concerns", "AOB - Please provide details in Issue Description"])

        const [employeesOptions, setEmployeesOptions] = useState([])
        const [sendToNo, setSetToNo] = useState('')
        const [inditedNo, setInditedNo] = useState('')
        const [caseDetails, setCaseDetails] = useState('')
        const [copyTo, setCopyTo] = useState('')
        const [witnesses, setWitnesses] = useState([])
        const [ctype, setType] = useState('')
        const [category, setCategory] = useState('')
        const [raisedDate, setRaisedDate] = useState(formatDate(new Date))
        const [incidentDate, setIncidentDate] = useState(formatDate(new Date))
        const [gDCode, setGDCode] = useState('')
        const [selectedEntryType, setSelectedEntryType] = useState('Issue Detail Description')
        const [wholeCase, setWholeCase] = useState(null)
        const [isLoading, setIsLoading] = useState(false)
        
        const [gvLines, setGvLines] = useState([])

        const handleAddItem = () =>{
            const itemLine =  {
                "EntryType": selectedEntryType,
                "Description": description
            }
            
            setGvLines([...gvLines, itemLine])
            tog_item()
        }

        const handleRemoveItem = (key) =>{
            const newItems = [...gvLines];
            newItems.splice(key, 1);
            setGvLines(newItems);
        }
    

        toastr.options = TOAST_OPTIONS;

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_case = () => {
            setmodal(!modal);
            removeBodyCss();
        }
        const tog_details = () => {
            setmodal_details(!modal_details);
            removeBodyCss();
        }
        const handleSendChange = (x) =>{
            setSetToNo(x.value)
        }
        const handleInditedChange = (x) =>{
            setInditedNo(x.value)
        }
        const handleCaseChange = (x) =>{
            setCaseDetails(x.value.Description)
            setGDCode(x.value.Code)
            setCategory(x.value.Type)
            setType(x.value.DesciplinaryCategory)
        }
        const handleCoptToChange = (x) =>{
            setCopyTo(x.value)
        }

        const handleSaveCase = () =>{
            let data = {}
            if(natureofGrievance == 'Person'){
                data = {
                    GDCode: gDCode,
                    CaseRegisteredByNo: empNo,
                    NatureofGrievance: natureofGrievance,
                    ProcessType: processType,
                    EmployeeNo: inditedNo,
                    IncidentDate: incidentDate,
                    DateRaised: raisedDate,
                    CopyGrievancyTo: copyTo,
                    grievanceLines:gvLines
                }
            }else if(natureofGrievance == 'Process'){
                data = {
                    GDCode: gDCode,
                    CaseRegisteredByNo: empNo,
                    NatureofGrievance: natureofGrievance,
                    ProcessType: processType,
                    IncidentDate: incidentDate,
                    DateRaised: raisedDate,
                    SendGrievanceTo: sendToNo,
                    CopyGrievancyTo: copyTo,
                    grievanceLines:gvLines
                }
            }
            
            setIsloading(true)
            axios.post(url.GRIEVENCES, data, HRConfig).then((r)=>{        
                if(r.request.status == '201'){
                    history.push(`/grievance-details/${r.data.SystemId}`)
                    toastr.success(`Case ${r.data.No} has been logged, you can now submit it`)
                }else{
                    toastr.error("Could not Create Case")
                }
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                toastr.error(e.response.data.error.message)
                setIsloading(false)
            })
       
        }

        const getData = () =>{
            setIsloading(true)
            if (localStorage.getItem("authMildUser")) {
                const obj = JSON.parse(localStorage.getItem("authMildUser"));
                setEmpNo(obj.uid)
                setEmpName(obj.staffname)
                axios.get(url.EMPLOYEES + "?$filter=No eq '"+ obj.uid +"'&company="+ obj.activeCompany, HRConfig)
                .then(function(response){
                    if(response.data.value.length > 0){
                        setEmpNo(response.data.value[0].No);
                        setEmpTitle(response.data.value[0].JobTitle);
                        setUserError(false);
                        setIsloading(false)
                    }else{
                        toastr.error("Employee Details Not Found in Business Central");
                    }
                }).catch(function (error) {
                    setIsloading(false)
                    toastr.error(error.response.data.error.message);
                    setUserError(true);
                    console.log(error);
                })
                .then(function () {
                // always executed
            });
            }
            const obj = JSON.parse(localStorage.getItem("authMildUser"));
            const EmployeeNo = obj.uid;
            axios.get(url.EMPLOYEES +"?$filter=No eq '"+ EmployeeNo +"'&company="+ obj.activeCompany, HRConfig).then((r)=>{ 
                let options = []
                r.data.value.map((e)=>{
                    options.push({label: `${e.FirstName} ${e.LastName}`,value: e.No})
                })
                setEmployeesOptions(options)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.GRIEVANCE_TYPES, HRConfig).then((r)=>{ 
                let options = []
                r.data.value.map((e)=>{
                    options.push({label: `${e.Description}`,value: e})
                })
                setCaseOptions(options)
            }).catch((e)=>{ console.log(e) })
        }
        useEffect(()=>{
           getData()
        },[])



        
    
          const tog_item = () => {
            setmodal_item(!modal_item);
            removeBodyCss();
          }

        toastr.options = TOAST_OPTIONS;

      

        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
       
        

        

        
        return (
      
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Raise Grievance | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Raise Grievance" />
                        <div>
                        {userError && ( 
                        <Alert color="danger" role="alert">
                                    Your Employee Number Not Found in Dynamics 365 Business Central
                        </Alert>
                        )}

                        {(ipaSaved == false) ? (
                        <Row>
                        <Col xl={4}>
                        <Card>
                            <CardBody>
                            <CardTitle>Personal Details</CardTitle>
                                    <Row>
                                    <Col md={12}>
                                        <div className="form-floating mb-3">
                                        <input type="text" className="form-control EmployeeNo" disabled={true}  value = {empNo} onChange={handleChange}  />
                                        <label htmlFor="floatingIdInput">No</label>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="form-floating mb-3">
                                        <input  type="text" className="form-control" disabled={true} defaultValue={empName} onChange={handleChange}   />
                                        <label htmlFor="floatingnameInput">Name</label>
                                        </div>
                                    </Col>
                                    </Row>
                                    <Row>
                              
                                    <Col md={12}>
                                        <div className="form-floating mb-3">
                                        <input  type="text" className="form-control" disabled={true} defaultValue={empTitle} onChange={handleChange} />
                                        <label htmlFor="floatingDepartInput">Title</label>
                                        </div>
                                    </Col>
                                   
                                </Row>
                                
                                
                                </CardBody>
                            </Card>

                            </Col>
                            <Col  xl={8}>
                            <Card>
                            <CardBody>
                            <CardTitle></CardTitle>
                                <Row>
                                <Col md={4} className=" mb-3">
                                        
                                        <label htmlFor="floatingDepartInput">Grievance</label>
                                        <Select options={caseOptions} classNamePrefix="select" isClearable={true} isSearchable={true} onChange={handleCaseChange} />
                                       
                                </Col>
                                <Col lg={4}>
                                                <div className=" mb-3">
                                                <label htmlFor="floatingDepartInput">Nature Of Grievance</label>
                                                <select className='form-select' onChange={(e)=>{setNatureofGrievance(e.target.value)}}>
                                                    <option value="">Select</option>
                                                    <option value="Person">Person</option>
                                                    <option value="Process">Process</option>
                                                  </select>
                                                    
                                                </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">Process Type</label>
                                        <select className="form-select" onChange={(e)=>setProcessType(e.target.value)} >
                                            <option value="">Select</option>
                                            {pTypeList.map((e,k)=>(<option key={k} value={e}>{e}</option>))}
                                        </select>
                                        </div>
                                    </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">GD Code</label>
                                        <Input type="text" className="form-control" defaultValue={gDCode} disabled={true} />
                                        
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">Date of Incident</label>
                                        <Flatpickr
                                                    className="form-control"
                                                    onChange={(e)=>{setIncidentDate(formatDate(e))}}
                                                    options={{
                                                        altInput: true,
                                                        altFormat: "F j, Y",
                                                        dateFormat: "Y-m-d",
                                                        disabled: true

                                                    }}
                                                    />
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">Date Raised</label>
                                        <Flatpickr
                                                    className="form-control"
                                                    onChange={(e)=>{setRaisedDate(formatDate(e))}}
                                                    options={{
                                                        altInput: true,
                                                        altFormat: "F j, Y",
                                                        dateFormat: "Y-m-d",
                                                        disabled: true

                                                    }}
                                                    />
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">Type</label>
                                        <Input type="text" className="form-control" defaultValue={ctype} disabled={true} />
                                        </div>
                                    </Col>
                                 
                                    <Col md={4}>
                                    <div className="mb-3">
                                        <label htmlFor="floatingDepartInput">Category</label>
                                        <Input type="text" className="form-control" disabled={true} defaultValue={category} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className=" mb-3">
                                        <label htmlFor="floatingDepartInput">Send Grievance To</label>
                                        <Select options={employeesOptions} classNamePrefix="select" isClearable={true} isSearchable={true}   onChange={handleSendChange}  />
                                        </div>
                                    </Col>
                             
                                    <Col md={4}>
                                        <div className=" mb-3">
                                        <label htmlFor="floatingDepartInput">Copy Grievance To</label>
                                        <Select options={employeesOptions} classNamePrefix="select" isClearable={true} isSearchable={true}   onChange={handleCoptToChange}  />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className=" mb-3">
                                        <label htmlFor="floatingDepartInput">Name of Indicted</label>
                                        <Select  options={employeesOptions}  classNamePrefix="select" isClearable={true} isSearchable={true} onChange={handleInditedChange}  />
                                        </div>
                                    </Col>
                          
                                 
                                  
                                    
                                    </Row>
                                    </CardBody>
                                    </Card>
                                 
                                    {(gvLines || []).map((g, key)=>(
                                        <Row key={key}>
                                            <Col>
                                            <Card>
                                        <CardBody>
                                
                                        <CardTitle className="mb-3">
                                        Grievance line  {key+1} 
                                        </CardTitle>
                                            <Row >
                        
                                            <Col lg={3}>
                                            <div className="mb-3">
                                                <label htmlFor="floatingSelectGrid">Entry Type</label>
                                                <input  type="text" className="form-control" defaultValue={g.EntryType} disabled={true} />
                                            </div>
                                            </Col>
                                            <Col lg={7}>
                                            <div className="mb-3">
                                                <label htmlFor="floatingSelectGrid">Description</label>
                                                <input  type="text" className="form-control" defaultValue={g.Description} disabled={true} />
                                            </div>
                                            </Col>
                                       
                                            <Col lg={2} >
                                                
                                                
                                                <input
                                                    type="button"
                                                    className="btn btn-primary position-absolute fixed-bottom mb-3"
                                                    value="Remove"
                                                    onClick={() => handleRemoveItem(key)}
                                                />
                                               
                                            </Col>
                                            </Row>
                                            </CardBody>
                                            </Card>
                                            </Col>
                                        </Row>
                                    ))}

                                    <Row>
                                            <Col md={6}>
                                                <div className="d-grid gap-2">
                                                    <input
                                                        type="button"
                                                        className="btn btn-success mt-3 mt-lg-0"
                                                        value="Add Grievance Line"
                                                        onClick={() => {  tog_item() }}
                                                    />
                                                </div>
                                            </Col>
                                            {(gvLines.length > 0) && (
                                            <Col md={6}>
                                                <div className="d-grid gap-2">
                                                    <Button color="primary" type="button" className="btn" onClick={handleSaveCase}>
                                                        Save Grievance
                                                    </Button>
                                                </div>
                                            </Col>
                                            )}
                                    </Row>

                                
                            </Col>
                            <Col>
                           
                                
                                    
                            <Modal
                                  isOpen={modal_item}
                                  toggle={() => {
                                    tog_item()
                                  }}
                                  centered
                                >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Add Grievance Line</h5>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setmodal_item(false);
                                      }}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                            
                                    
                                
                                     
                                            <Row >
                        
                                            <Col lg={12}>
                                                <div className="mb-3">
                                                <label htmlFor="floatingDepartInput">Entry Type</label>
                                                <select className='form-select' onChange={(e)=>{setSelectedEntryType(e.target.value)}}>
                                                    <option value="">Select</option>
                                                    {entryTypes.map((e,k)=>(<option key={k} value={e}>{e}</option>))}
                                                  </select>
                                                    
                                                </div>
                                            </Col>
                                     
                                           
                                            
                                            <Col lg={12}>
                                            <div className="mb-3">
                                                <label htmlFor="floatingSelectGrid">Description</label>
                                                <input  type="text" className="form-control" onChange={(e)=>setDescription(e.target.value)}   />
                                                
                                            </div>
                                            </Col>
                                            
                                            
                                         
                                            </Row>
                                          
                                            
                                            </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      onClick={() => {  tog_item() }}
                                      className="btn btn-danger "
                                      data-dismiss="modal"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-success "
                                      onClick={()=>{handleAddItem()}}
                               
                                    >
                                      Add Line...
                                    </button>
                                  </div>
                                </Modal>
              
                                            
                                            <br/>
              
                                           
                    
                        </Col>
                        </Row>
                        ):(
                            <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                <Card outline color="success" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    <CardText>
                                        
                                    </CardText>
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>Saved</h5>
                                        <p className="text-muted">
                                                Grievance <strong>{ipaNo}</strong> Saved!
                                        </p>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                        )}
                        </div>


                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
         

        );
    }

export default AddGrievanceCase;